import React from 'react'
import animationWebp from 'root/src/client/public/animation/multicoloredcircles.webp'
import withStyles from '@material-ui/core/styles/withStyles'
import Image from 'next/future/image'

const style = {
	root: {
		margin: 'auto',
	},
}
const LoadingCircles = ({ classes, width = 200, height = 200 }) => (
	<div className={classes.root}>
		<Image
			src={animationWebp.src}
			alt="multicolored circles"
			width={width}
			height={height}
			unoptimized
		/>
	</div>
)

export default withStyles(style, { name: 'MuiLoadingCircles' })(LoadingCircles)
